import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import MediaCarouselSchema from './schema';
import MediaCarouselView from './MediaCarouselView';
import type { MediaCarouselData } from './MediaCarouselView';

type MediaCarouselEditProps = {
  data: MediaCarouselData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: MediaCarouselData) => void;
};

const MediaCarouselEdit = (props: MediaCarouselEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = MediaCarouselSchema({ intl });

  return (
    <>
      <MediaCarouselView data={data} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default MediaCarouselEdit;
